module.exports = __webpack_public_path__ + "static/media/illustration.103807c5.svg";